import Reflux from 'reflux'

export default Reflux.createActions([
	'showLoginModal',
	'hideLoginModal'
])



// WEBPACK FOOTER //
// ./src/actions/app.js